import { LIVE_CHAT_TABS } from "../../configs/constants"
import { formatAndBindToJSONToDayjs, getDateRange } from "../../utils"

const dateRange = getDateRange({start_date_difference: 7})

const initialState = {
  isSocketConnected: false,
  socketRequestProcessing: false,
  pageJoining: false,
  selectedChatListTab: LIVE_CHAT_TABS.ALL_CHATS,
  liveChats: {},
  unseenLiveChatCount: 0,
  botChatPsids: [],
  inQueuePsids: [],
  myChatPsids: [],
  otherAgentChatPsids: [],
  allChats: [],
  allChatsLoading: false,
  selectedDateFilter: {
    endDate: formatAndBindToJSONToDayjs(dateRange[1], "end"),
    startDate: formatAndBindToJSONToDayjs(dateRange[0]),
  },
  lastScannedTicketId: "",
  selectedChats: {},
  selectedChatId: null,
  unreadMessageCountMap: {},
  hasMore: false
}

export default initialState
